import type { WeightClass } from '@relay-towing/ui';

/** "2019 Ford F-150", from whichever of year, make and model are known. */
export function vehicleOf(
  vehicle:
    | {
        vehicleYear?: number | string | null;
        vehicleName?: string | null;
        vehicleMake?: string | null;
        vehicleModel?: string | null;
      }
    | null
    | undefined
): string | undefined {
  if (!vehicle) return undefined;
  return (
    [
      vehicle.vehicleYear,
      vehicle.vehicleMake ?? vehicle.vehicleName,
      vehicle.vehicleModel,
    ]
      .filter(Boolean)
      .join(' ') || undefined
  );
}

/**
 * A call's weight class from its tow type, for the bars in a list row. Only
 * the three duty classes have one; a motorcycle or a container is a kind
 * of tow, not a weight, and draws no bars.
 */
export function weightClassOf(
  towType: string | null | undefined
): WeightClass | undefined {
  if (towType === 'LIGHT') return 'light';
  if (towType === 'MEDIUM') return 'medium';
  if (towType === 'HEAVY') return 'heavy';
  return undefined;
}
